<template>
	<div :class="classes">
		<div class="showmore-items__primary" v-if="$slots.primary">
			<slot name="primary"></slot>
		</div>
		<div class="showmore-items__secondary" v-if="$slots.secondary">
			<NavSidebarItem
				v-if="!isExpanded"
				class="nav-sidebar__item"
				:is-selected="false"
				:show-guide="false"
				@click="toggleExpansion"
			>
				<template v-slot:text>
					{{ translate( "showMoreLabel" ) }}
					<FontAwesomeIcon :icon="['fas', 'angle-double-down']" />
				</template>
			</NavSidebarItem>
			<slot name="secondary" v-if="isExpanded"></slot>
			<NavSidebarItem
				v-if="isExpanded"
				class="nav-sidebar__item"
				:is-selected="false"
				:show-guide="false"
				@click="toggleExpansion"
			>
				<template v-slot:text>
					{{ translate( "showFewerLabel" ) }}
					<FontAwesomeIcon :icon="['fas', 'angle-double-up']" />
				</template>
			</NavSidebarItem>

		</div>
	</div>
</template>

<script>
import NavSidebarItem from "./NavSidebarItem";

export default {
	name: "ShowmoreItems",
	emits: [ "toggle", ],
	components: {
		NavSidebarItem,
	},
	props: {
		class: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			isExpanded: false,
		};
	},
	computed: {
		classes() {
			return {
				"showmore-items": true,
				[ this.class ]: !!this.class,
			};
		},
	},
	methods: {
		translate( key, args ) {
			return this.$t( `teaming-web.layouts.ShowmoreItems.${ key }`, args );
		},
		async toggleExpansion() {
			this.isExpanded = !this.isExpanded;
			await this.$nextTick();
			this.$emit( "toggle", { isExpanded: this.isExpanded, } );
		},
	},
};
</script>
